import { Injectable, inject } from '@angular/core'
import {
  AbstractControl,
  FormGroup,
  NonNullableFormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms'
import { OrderForm, OrderFormControls } from '../domain/orders/order-form.model'

@Injectable({
  providedIn: 'root'
})
export class OrderFormService {
  private readonly fb = inject(NonNullableFormBuilder)

  getDocumentsForm(): FormGroup<Pick<OrderFormControls, 'documents'>> {
    return this.fb.group({
      documents: this.fb.array<
        OrderFormControls['documents']['controls'][number]
      >([])
    })
  }

  getDocumentForm(
    document?: OrderForm['documents'][number]
  ): OrderFormControls['documents']['controls'][number] {
    return this.fb.group({
      id: this.fb.control<string | undefined>(document?.id),
      type: this.fb.control<string | undefined>(
        document?.type,
        Validators.required
      ),
      hasSignature: this.fb.control<boolean | undefined>(
        document?.hasSignature
      ),
      signatureDate: this.fb.control<Date | undefined>(
        document?.signatureDate,
        this.notInFutureValidator()
      )
    })
  }

  notInFutureValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value
      if (!value) return null
      return new Date(value) > new Date() ? { futureDate: true } : null
    }
  }
}
